import React, { useContext, useEffect, useRef, useState } from "react";
import { getDateHelper, getFrequencyDates, getPriceHelper, minutesToHour, setDateHelper } from "../../utils/Helper";
import useMakeRequest from "../../utils/ApiHelper";
import { ApiConstants } from "../../constants/ApiConstants";
import ReactSelect from "react-select";
import DatePicker from "react-datepicker";
import calLogo from '../../assets/images/calender.svg'
import Button from "../../components/ui/Button";
import moment from "moment";
import Skeleton from "../../components/ui/Skeleton";
import authContext from "../../context/authContext";
import { ApiTypes, HOUSEHOLD_TYPES } from "../../constants/Constants";
import chevRight from '../../assets/images/chev-right.svg'
import SortIcon from '../../assets/images/sort-icon.svg'
import CustomInput from "../../components/ui/CustomInput";
import CustomReactSelect from "../../components/ui/CustomReactSelect";



const ChoresReport = ({ doneByOptions }: any) => {

    const chores = useMakeRequest();
    let profile: any = useContext(authContext);
    profile = profile?.data;
    const hhMembers = useMakeRequest();
    const choresCateg = useMakeRequest();
    const scrollDivRef: any = useRef(null);

    const [isChoreChartExpanded, setIsChoreChartExpanded] = useState(true);

    const [choresOptions, setChoresOptions] = useState([{ value: '', label: '', price: '' }]);
    const [choresFilter, setChoresFilter]: any = useState();
    const [choresList, setChoresList] = useState<any[]>([]);
    const [filteredChoresList, setFilteredChoresList] = useState<any[]>([]);

    const [hoursMemberWise, setHoursMemberWise] = useState([])
    const [choresTotalHourPrice, setChoresTotalHourPrice] = useState({ total_hours: 0, total_amount: 0 })

    const [filteredHoursMemberWise, setFilteredHoursMemberWise] = useState([])
    const [filteredChoresTotalHourPrice, setFilteredChoresTotalHourPrice] = useState({ total_hours: 0, total_amount: 0, total_hours_projected: 0, total_amount_projected: 0, total_hours_completed: 0, total_amount_completed: 0 })
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });

    const [expandedSections, setExpandedSections] = useState<{ [key: string]: boolean }>({
        totalHours: false,
        totalExpenses: false,
        totalPaid: false,
        totalUnpaid: false,
        currentBalances: false,
        finalizedBalances: false
    });


    useEffect(() => {
        chores.makeRequest({ url: ApiConstants?.ChoresGet })
        setChoresFilter({
            s_date: null,
            e_date: null,
            h_spent: '',
            done_by: null,
            cc_id: null
        });
    }, [])

    useEffect(() => {
        if (choresCateg?.status) {
            const transformedData = choresCateg?.data?.data?.map((item: any) => ({
                value: item?.uuid,
                label: item?.name,
                price: item?.national_cost,
            }));
            setChoresOptions(transformedData);
        }
    }, [choresCateg?.status]);

    useEffect(() => {
        hhMembers.makeRequest({ url: ApiConstants?.GetHouseholdMembers })
        choresCateg.makeRequest({ url: ApiConstants?.ChoresCategories, type: ApiTypes?.GET })
    }, [])

    useEffect(() => {
        if (chores?.status && hhMembers?.status) {
            const choresRows = chores?.data?.data?.rows;
            const modifiedChoreses = chores?.data?.data?.modified_chores;

            const choresArr: any = [];
            const hoursMemberWiseArr: any = {};
            let totalChoresHour = 0;
            let totalChoresAmount = 0;

            hhMembers?.data?.data?.forEach((member: any) => {
                const userUUID = member?.user?.uuid;
                if (userUUID) {
                    hoursMemberWiseArr[userUUID] = {
                        name: member?.user?.name,
                        profile_pic: member?.user?.profile_pic,
                        email: member?.user?.email,
                        hours_spent: 0
                    };
                }
            });

            if (choresRows?.length > 0) {
                choresRows?.forEach((choresData: any) => {
                    const sDate = choresData?.s_date;
                    const eDate = choresData?.e_date;
                    const fType = choresData?.f_type;
                    const fValue = choresData?.f_value;
                    const hSpent = choresData?.h_spent;
                    const cName = choresData?.chores_cat;
                    const dBy = choresData?.done_by;
                    const selectedDaysOrMonths = choresData?.s_days_or_months;
                    const freqDays = getFrequencyDates(
                        sDate,
                        eDate,
                        fType,
                        fValue,
                        selectedDaysOrMonths
                    );

                    const mappedChores = freqDays.map((date: string) => {
                        const modifiedChores = modifiedChoreses.find(
                            (modChores: any) => moment(modChores.m_date).format('YYYY-MM-DD') === date && modChores.c_id === choresData?.id
                        );

                        if (modifiedChores && modifiedChores?.is_deleted) {
                            return null;
                        }

                        if (modifiedChores) {
                            return {
                                ...choresData,
                                ...modifiedChores,
                                date,
                                hour_spent: minutesToHour(modifiedChores?.m_h_spent),
                                chores: cName,
                                done_by: modifiedChores?.done_by,
                                minutes_spent: modifiedChores?.m_h_spent,
                                is_modified: true,
                                amount: modifiedChores.amount || choresData.amount
                            };
                        } else {
                            return {
                                date,
                                ...choresData,
                                minutes_spent: hSpent,
                                hour_spent: minutesToHour(hSpent),
                                chores: cName,
                                done_by: dBy,
                                is_modified: false
                            };
                        }
                    }).filter(Boolean);

                    choresArr.push(...mappedChores);

                    mappedChores.forEach((chore: any) => {
                        const memberUUID = chore.done_by?.value;
                        if (memberUUID && hoursMemberWiseArr[memberUUID]) {
                            hoursMemberWiseArr[memberUUID].hours_spent += chore.minutes_spent;
                        }
                    });

                    const totalHours = mappedChores.reduce((sum: number, chore: any) => {
                        return sum + chore.minutes_spent;
                    }, 0);

                    const totalAmount = mappedChores.reduce((sum: number, chores: any) => {
                        const finalSum = sum + (Number(chores?.c_price) * Number(chores?.hour_spent));
                        const roundedFinalSum = parseFloat(finalSum.toFixed(2));
                        return roundedFinalSum;
                    }, 0);
                    totalChoresAmount += totalAmount;
                    totalChoresHour += totalHours;
                });
                choresArr.sort((a: any, b: any) => moment(a.date).valueOf() - moment(b.date).valueOf());
            }

            setChoresTotalHourPrice({
                total_hours: totalChoresHour,
                total_amount: totalChoresAmount
            });
            setFilteredChoresTotalHourPrice({
                total_hours: totalChoresHour,
                total_amount: totalChoresAmount,
                total_hours_projected: totalChoresHour,
                total_amount_projected: totalChoresAmount,
                total_hours_completed: totalChoresHour,
                total_amount_completed: totalChoresAmount
            });
            setHoursMemberWise(hoursMemberWiseArr);
            setFilteredHoursMemberWise(hoursMemberWiseArr);
            setChoresList(choresArr);
            setFilteredChoresList(choresArr);
        }
    }, [chores?.status, hhMembers?.status]);

    const handleScroll = () => {
        return
        // if (page <= getPastRides?.data?.data?.last_page) {
        // const div = scrollDivRef?.current;
        // if (div) {
        //     const { scrollTop, scrollHeight, clientHeight } = div;
        //     if ((Math.round((scrollTop + clientHeight) * 100 / scrollHeight) === 100)) {
        //         setPage(page + 1);
        //     }
        // }
        // }
    };

    const handleFilter = (type: string = 'FILTER') => {
        if (type === 'RESET') {
            setChoresFilter({
                s_date: null,
                e_date: null,
                h_spent: '',
                done_by: null,
                cc_id: null,
                status: null
            });

            setFilteredChoresList(choresList);
            setFilteredChoresTotalHourPrice({
                total_hours: choresTotalHourPrice.total_hours,
                total_amount: choresTotalHourPrice.total_amount,
                total_hours_projected: choresTotalHourPrice.total_hours,
                total_amount_projected: choresTotalHourPrice.total_amount,
                total_hours_completed: choresTotalHourPrice.total_hours,
                total_amount_completed: choresTotalHourPrice.total_amount
            });
            setFilteredHoursMemberWise(hoursMemberWise);
            return;
        }

        let { cc_id, done_by, s_date, e_date, h_spent, status } = choresFilter || {};

        const choreId = cc_id?.value;
        const memberId = done_by?.value;
        const statusValue = status?.value;

        const filteredChores = choresList.filter((chore: any) => {
            let isMatch = true;

            // ✅ Filter by Chore
            if (choreId && chore?.chores?.value !== choreId) {
                isMatch = false;
            }

            // ✅ Filter by Member
            if (memberId && chore?.done_by?.value !== memberId) {
                isMatch = false;
            }

            // ✅ Filter by Status
            if (statusValue && chore?.status !== statusValue) {
                isMatch = false;
            }

            // ✅ Filter by Hours
            if (h_spent && Number(chore?.hour_spent) !== Number(h_spent)) {
                isMatch = false;
            }

            // ✅ Filter by Date Range
            const choreDate = moment(chore?.date);

            if (s_date && !e_date) {
                if (choreDate.isBefore(moment(s_date).startOf('day'))) {
                    isMatch = false;
                }
            }

            if (!s_date && e_date) {
                if (choreDate.isAfter(moment(e_date).endOf('day'))) {
                    isMatch = false;
                }
            }

            if (s_date && e_date) {
                if (
                    choreDate.isBefore(moment(s_date).startOf('day')) ||
                    choreDate.isAfter(moment(e_date).endOf('day'))
                ) {
                    isMatch = false;
                }
            }

            return isMatch;
        });

        // ===============================
        // Totals Calculation
        // ===============================

        const totalFilteredHours = filteredChores.reduce((sum: number, chore: any) => {
            return sum + chore.minutes_spent;
        }, 0);

        const totalFilteredAmount = filteredChores.reduce((sum: number, chore: any) => {
            return sum + Number(chore?.c_price * chore?.hour_spent);
        }, 0);

        const filteredCompletedChores = filteredChores.filter(
            (chore: any) => chore.status === 3
        );

        const totalCompletedHours = filteredCompletedChores.reduce((sum: number, chore: any) => {
            return sum + chore.minutes_spent;
        }, 0);

        const totalCompletedAmount = filteredCompletedChores.reduce((sum: number, chore: any) => {
            return sum + Number(chore?.c_price * chore?.hour_spent);
        }, 0);

        // ===============================
        // Member Wise Hours
        // ===============================

        const filteredHoursMemberWiseArr: any = {};

        hhMembers?.data?.data?.forEach((member: any) => {
            const userUUID = member?.user?.uuid;

            if (userUUID) {
                filteredHoursMemberWiseArr[userUUID] = {
                    name: member?.user?.name,
                    profile_pic: member?.user?.profile_pic,
                    email: member?.user?.email,
                    hours_spent: 0
                };
            }
        });

        filteredChores.forEach((chore: any) => {
            const memberUUID = chore.done_by?.value;

            if (memberUUID && filteredHoursMemberWiseArr[memberUUID]) {
                filteredHoursMemberWiseArr[memberUUID].hours_spent += chore.minutes_spent;
            }
        });

        setFilteredChoresTotalHourPrice({
            total_hours: totalFilteredHours,
            total_amount: parseFloat(totalFilteredAmount.toFixed(2)),
            total_hours_projected: totalFilteredHours,
            total_amount_projected: parseFloat(totalFilteredAmount.toFixed(2)),
            total_hours_completed: totalCompletedHours,
            total_amount_completed: parseFloat(totalCompletedAmount.toFixed(2))
        });

        setFilteredHoursMemberWise(filteredHoursMemberWiseArr);
        setFilteredChoresList(filteredChores);
    };

    const handleSort = (key: any) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const toggleSection = (section: string) => {
        setExpandedSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    }

    return (
        <>
            <div className="page-padding-x box-bg pt-2">
                <div className="com-input-grp mb-4 mt-2">
                    <div className="input-header">
                        <label className="form-label-large">Chore Chart</label>
                        <div className="filter-section" onClick={() => setIsChoreChartExpanded(!isChoreChartExpanded)} style={{ cursor: 'pointer' }}>
                            <span>Filter</span>
                            <img
                                src={chevRight}
                                alt="chevron"
                                style={{
                                    transform: isChoreChartExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                                    transition: 'transform 0.3s ease'
                                }}
                            />
                        </div>
                    </div>
                </div>

                {isChoreChartExpanded && (
                    <>
                        <div className="row gy-3">
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label d-block">Start Date</label>
                                    <DatePicker
                                        className='form-control'
                                        placeholderText="Select Date"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        selected={choresFilter?.s_date ? moment(choresFilter?.s_date).toDate() : null}
                                        showIcon
                                        icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                        onChange={(start_date: any) => {
                                            setChoresFilter({ ...choresFilter, s_date: setDateHelper({ date: start_date }), e_date: '' })
                                        }}
                                        minDate={moment(profile?.hh_member?.billing_date).toDate()}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label d-block">End Date</label>
                                    <DatePicker
                                        className='form-control'
                                        placeholderText="Select Date"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        selected={choresFilter?.e_date ? moment(choresFilter?.e_date).toDate() : null}
                                        showIcon
                                        icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                        onChange={(start_date: any) => {
                                            setChoresFilter({ ...choresFilter, e_date: setDateHelper({ date: start_date }) })
                                        }}
                                        minDate={new Date(new Date(choresFilter?.s_date).setDate(new Date(choresFilter?.s_date).getDate() + 1))}
                                    />
                                </div>
                            </div>

                            <div className="col-6">
                                <CustomReactSelect
                                    label="Status"
                                    value={choresFilter?.status}
                                    options={[{ value: 1, label: "Unassigned" }, { value: 2, label: "Assigned" }, { value: 3, label: "Completed" },]}
                                    className="com-r-select"
                                    classNamePrefix="com-r-select"
                                    placeholder="Select Status"
                                    onChange={(selectedOption: any) => {
                                        setChoresFilter({ ...choresFilter, status: selectedOption })
                                    }}
                                    closeMenuOnScroll={true}
                                    closeMenuOnSelect={true}
                                />

                            </div>
                            <div className="col-6">
                                <CustomReactSelect
                                    label="Member"
                                    value={choresFilter?.done_by}
                                    options={[
                                        ...(Array.isArray(doneByOptions) ? doneByOptions : []),
                                    ]}
                                    className="com-r-select"
                                    classNamePrefix="com-r-select"
                                    placeholder="Select Member"
                                    isLoading={hhMembers?.loading}
                                    onChange={(selectedOption) => {
                                        setChoresFilter({ ...choresFilter, done_by: selectedOption })
                                    }}
                                    closeMenuOnScroll={true}
                                    closeMenuOnSelect={true}
                                />

                            </div>
                            <div className="col-6">
                                <CustomReactSelect
                                    label="Chore"
                                    value={choresFilter?.cc_id}
                                    options={[...choresOptions]}
                                    className="com-r-select"
                                    classNamePrefix="com-r-select"
                                    placeholder="Select Chore"
                                    onChange={(selectedOption: any) => {
                                        setChoresFilter({ ...choresFilter, cc_id: selectedOption })
                                    }}
                                    closeMenuOnScroll={true}
                                    closeMenuOnSelect={true}
                                />

                            </div>
                            <div className="col-6">
                                <CustomInput
                                    label="Hours"
                                    type="text"
                                    className="form-control"
                                    placeholder='Enter Hours'
                                    max={24}
                                    min={0}
                                    value={choresFilter?.h_spent}

                                    onInput={(e: any) => {
                                        let value = e.target.value.replace(/[^0-9.]/g, '');
                                        if (value === '') {
                                            setChoresFilter({ ...choresFilter, h_spent: '' })
                                            return;
                                        }
                                        if (value.includes('.') && parseInt(value.split('.')[0]) >= 24) { return; }
                                        if (value.match(/^\d{1,2}(\.\d{0,2})?$/)) {
                                            const [hours, minutes] = value.split('.');
                                            if (parseInt(hours) > 24) { value = '24'; }
                                            if (minutes && parseInt(minutes) > 59) {
                                                value = `${hours}.59`;
                                            }
                                            e.target.value = value;
                                            setChoresFilter({ ...choresFilter, h_spent: value })
                                        }
                                    }}
                                />
                            </div>
                        </div>

                        {/* <div className="row gy-3">
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label d-block">Start Date</label>
                                    <DatePicker
                                        className='form-control'
                                        placeholderText="MM/DD/YYYY"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        selected={choresFilter?.s_date ? moment(choresFilter?.s_date).toDate() : null}
                                        showIcon
                                        icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                        onChange={(start_date: any) => {
                                            setChoresFilter({ ...choresFilter, s_date: setDateHelper({ date: start_date }), e_date: '' })
                                        }}
                                        minDate={moment(profile?.hh_member?.billing_date).toDate()}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label d-block">End Date</label>
                                    <DatePicker
                                        className='form-control'
                                        placeholderText="MM/DD/YYYY"
                                        timeFormat="MM DD YYYY"
                                        onKeyDown={(e: any) => e.preventDefault()}
                                        showYearDropdown
                                        scrollableYearDropdown
                                        yearDropdownItemNumber={50}
                                        selected={choresFilter?.e_date ? moment(choresFilter?.e_date).toDate() : null}
                                        showIcon
                                        icon={<><img className="calIcon" src={calLogo} alt="" /></>}
                                        onChange={(start_date: any) => {
                                            setChoresFilter({ ...choresFilter, e_date: setDateHelper({ date: start_date }) })
                                        }}
                                        minDate={new Date(new Date(choresFilter?.s_date).setDate(new Date(choresFilter?.s_date).getDate() + 1))}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label">Hours Spent</label>
                                    <input type="text" className="form-control" placeholder='Hour spent' max={24} min={0} value={choresFilter?.h_spent}
                                        onInput={(e: any) => {
                                            let value = e.target.value.replace(/[^0-9.]/g, '');
                                            if (value === '') {
                                                setChoresFilter({ ...choresFilter, h_spent: '' })
                                                return;
                                            }
                                            if (value.includes('.') && parseInt(value.split('.')[0]) >= 24) { return; }
                                            if (value.match(/^\d{1,2}(\.\d{0,2})?$/)) {
                                                const [hours, minutes] = value.split('.');
                                                if (parseInt(hours) > 24) { value = '24'; }
                                                if (minutes && parseInt(minutes) > 59) {
                                                    value = `${hours}.59`;
                                                }
                                                e.target.value = value;
                                                setChoresFilter({ ...choresFilter, h_spent: value })
                                            }
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="com-input-grp">
                                    <label className="form-label">Completed by</label>
                                    <div className='custom-select'>
                                        <ReactSelect
                                            value={choresFilter?.done_by}
                                            options={[
                                                { value: '', label: 'All' },
                                                ...(Array.isArray(doneByOptions) ? doneByOptions : []),
                                            ]}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            placeholder="Done by"
                                            isLoading={hhMembers?.loading}
                                            onChange={(selectedOption) => {
                                                setChoresFilter({ ...choresFilter, done_by: selectedOption })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-12">
                                <div className="com-input-grp">
                                    <label className="form-label">Chore</label>
                                    <div className='custom-select'>
                                        <ReactSelect
                                            value={choresFilter?.cc_id}
                                            options={[{ value: '', label: 'All' }, ...choresOptions]}
                                            isLoading={choresCateg?.loading}
                                            className="com-r-select"
                                            classNamePrefix="com-r-select"
                                            placeholder="Category"
                                            onChange={(selectedOption: any) => {
                                                setChoresFilter({ ...choresFilter, cc_id: selectedOption })
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div> */}

                        <div className='d-flex pt-2'>
                            <Button className='custom-grayed-btn modal-light-btn mt-2 me-4' style={{ width: "50%" }} type="button" onClick={() => handleFilter('RESET')}>Reset</Button>
                            <Button className='com-btn mt-2' style={{ width: "50%" }} type="button" onClick={handleFilter}>Filter</Button>
                        </div>
                    </>
                )}
            </div>
            <div className="box-bg pt-2">
                <div className="page-padding-x table-scroll-top" >
                    <div className='table-responsive table-y-scroll-2 report-table mb-2' ref={scrollDivRef} onScroll={handleScroll}>
                        <table className='table'>
                            <thead>
                                <tr>
                                    <th>Date

                                        <img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('date')}
                                        />
                                    </th>
                                    <th className="text-center">Chore

                                        <img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('chores')}
                                        />
                                    </th>
                                    <th className="text-center">Hours
                                        <img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('hours')}
                                        />
                                    </th>
                                    <th className="text-center">Member
                                        <img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('done_by')}
                                        />
                                    </th>
                                    <th className="text-center">Status
                                        <img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('status')}
                                        />
                                    </th>
                                    <th className="text-center">Description
                                        <img
                                            src={SortIcon}
                                            alt="Sort"
                                            className="sort-icon"
                                            onClick={() => handleSort('description')}
                                        />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    chores?.loading ?
                                        Array.from({ length: 10 })?.map(() => (
                                            <tr>
                                                <td className="text-center">
                                                    <Skeleton className='skeleton-loader' style={{ width: '100px', height: '20px' }} />
                                                </td>
                                                <td className="text-center">
                                                    <Skeleton className='skeleton-loader' style={{ width: '120px', height: '20px' }} />
                                                </td>
                                                <td className="text-center">
                                                    <Skeleton className='skeleton-loader' style={{ width: '140px', height: '20px' }} />
                                                </td>
                                                <td className="text-center">
                                                    <Skeleton className='skeleton-loader' style={{ width: '120px', height: '20px' }} />
                                                </td>
                                                <td className="text-center">
                                                    <Skeleton className='skeleton-loader' style={{ width: '120px', height: '20px' }} />
                                                </td>
                                                <td className="text-center">
                                                    <Skeleton className='skeleton-loader' style={{ width: '80px', height: '20px' }} />
                                                </td>
                                            </tr>
                                        )) :

                                        filteredChoresList?.length > 0 ?
                                            [...filteredChoresList]
                                                ?.sort((a, b) => {
                                                    const { key, direction } = sortConfig;
                                                    if (!key) return 0;

                                                    let aValue, bValue;

                                                    switch (key) {
                                                        case 'date':
                                                            aValue = new Date(a.date);
                                                            bValue = new Date(b.date);
                                                            break;
                                                        case 'chores':
                                                            aValue = a.chores?.label?.toLowerCase() || '';
                                                            bValue = b.chores?.label?.toLowerCase() || '';
                                                            break;
                                                        case 'hours':
                                                            aValue = parseFloat(a.hour_spent) || 0;
                                                            bValue = parseFloat(b.hour_spent) || 0;
                                                            break;
                                                        case 'done_by':
                                                            aValue = a.done_by?.label?.toLowerCase() || '';
                                                            bValue = b.done_by?.label?.toLowerCase() || '';
                                                            break;
                                                        case 'status':
                                                            aValue = a.status || 0;
                                                            bValue = b.status || 0;
                                                            break;
                                                        case 'description':
                                                            aValue = a.description?.toLowerCase() || '';
                                                            bValue = b.description?.toLowerCase() || '';
                                                            break;
                                                        default:
                                                            return 0;
                                                    }

                                                    if (aValue < bValue) return direction === 'asc' ? -1 : 1;
                                                    if (aValue > bValue) return direction === 'asc' ? 1 : -1;
                                                    return 0;
                                                })?.map((chore: any, choreIndex: any) => {
                                                    const date = getDateHelper({ date: chore?.date, format: 'MM/DD/YYYY' });
                                                    const hSpent = chore?.hour_spent;
                                                    const dBy = chore?.done_by?.label;
                                                    const cName = chore?.chores?.label;
                                                    let isHourExceed = false;
                                                    return (
                                                        <>
                                                            <tr className={isHourExceed ? 'row-error' : ''} key={choreIndex}>
                                                                <td>{date}</td>
                                                                <td className="text-center">{cName}</td>
                                                                <td className="text-center">{hSpent}</td>
                                                                <td className="text-center">{dBy}</td>
                                                                <td className="text-center">{chore.status == 1 ? 'Unassigned' : chore.status == 2 ? 'Assigned' : chore.status == 3 ? 'Completed' : ''}</td>
                                                                <td className="text-center">{chore.description || ''}</td>
                                                            </tr>
                                                        </>
                                                    )
                                                })
                                            :
                                            <>
                                                <tr>
                                                    <td colSpan={20}>
                                                        <p className="text-center mt-3">No Record Found</p>
                                                    </td>
                                                </tr>

                                            </>
                                }
                            </tbody>
                        </table>
                    </div>
                </div>

                <div className="divider" />
                <div className='summary-section'>
                    <h3 className='summary-title'>Summary</h3>

                    {/* Total Hours Projected */}
                    <div className='summary-item' tabIndex={0}>
                        <div className='summary-item-header'>
                            <span className='summary-item-label'>Total Hours Projected</span>
                            <span className='summary-item-value'>{minutesToHour(filteredChoresTotalHourPrice?.total_hours) || 0}</span>
                        </div>
                    </div>

                    {/* Total Hours Completed */}
                    <div
                        className='summary-item'
                        tabIndex={0}
                        role='button'
                        aria-expanded={expandedSections.totalHours}
                        onClick={() => toggleSection('totalHours')}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                toggleSection('totalHours');
                            }
                        }}
                    >
                        <div className='summary-item-header'>
                            <div className='summary-item-left'>
                                <span className='summary-item-label'>Total Hours Completed</span>
                                <span className='summary-item-arrow'>
                                    <img className={`accordion-arrow ${expandedSections.totalHours ? 'expanded' : ''}`} src={chevRight} alt="" />
                                </span>
                            </div>
                            <span className='summary-item-value'>
                                {minutesToHour(filteredChoresTotalHourPrice?.total_hours) || 0}
                            </span>
                        </div>
                    </div>
                    {expandedSections.totalHours && (
                        <div className='summary-item-expanded'>
                            {
                                Object.values(filteredHoursMemberWise)?.length > 0 ? Object.values(filteredHoursMemberWise)?.map((member: any, key: number) => (
                                    <div className='summary-sub-item' key={key}>
                                        <span className='summary-sub-label'>{member?.name}</span>
                                        <span className='summary-sub-value'>{minutesToHour(member?.hours_spent)}</span>
                                    </div>
                                ))
                                    : ''}
                            {/* {Object.entries(filteredHoursMemberWise).map(([id, user]) => {
                                console.log("user", user)
                                return (
                                    <div className='summary-sub-item'>
                                        <span className='summary-sub-label'>{user?.name}</span>
                                        <span className='summary-sub-value'>{minutesToHour(user?.hours_spent)}</span>
                                    </div>
                                )
                            })} */}
                        </div>
                    )}
                </div>

                {/* <div className="accordion chores-accordian mt-4" id="choresAccordian">
                    <div className="accordion-item">
                        <h2 className="accordion-header">
                            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                <i className="acco-close icon-add-circle"></i><i className="acco-open icon-minus-circle"></i>Total Hours of Chores <span className="ms-auto">{minutesToHour(filteredChoresTotalHourPrice?.total_hours)}</span>
                            </button>
                        </h2>
                        <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#choresAccordian">
                            <div className="accordion-body">
                                <div className="table-responsive">
                                    <table className="table chores-accordian-table m-0">
                                        <tbody>
                                            {
                                                Object.values(filteredHoursMemberWise)?.length > 0 ? Object.values(filteredHoursMemberWise)?.map((member: any) => (
                                                    <tr>
                                                        <td className="chores-img-wrap"><img src={member?.profile_pic} alt="" /></td>
                                                        <td>{member?.name}</td>
                                                        <td className="text-end">{minutesToHour(member?.hours_spent)}</td>
                                                    </tr>
                                                ))
                                                    : ''}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="pay-table-view pb-3">
                    <div className="pay-table-row fw-600">
                        <div className="">Total Hours</div>
                        <div className="">{minutesToHour(filteredChoresTotalHourPrice?.total_hours)}</div>
                    </div>
                    <div className="pay-table-row fw-600">
                        <div className="">Total Amount</div>
                        <div className="">{getPriceHelper(filteredChoresTotalHourPrice?.total_amount)}</div>
                    </div>
                </div> */}

            </div>
        </>
    )
}

export default ChoresReport
